(function(card) {
    card.meta = undefined; // this should be set post fetch process with the meta data for the current card

    card.content = (function(){
        return {
            fetch: fetch,
            mapData: mapData
        };
    }());

    card.utils = (function(){
        return {
            parseUrl: parseUrl,
            getQueryVar: getQueryVar,
            ajaxGet: ajaxGet,
            getImageUrl: getImageUrl,
            parseString: parseString,
            trimString: trimString,
            getParams: getParams
        };
    }());

    function getParams() {
        var parts = window.location.href.split('?');
        var kvps;
        var keyValuePair;
        var paramMap = {};
        var i;
        var len;

        if (parts.length === 2) {
            kvps = parts[1].split('&');

            for (i = 0, len = kvps.length; i < len; i++) {
                keyValuePair = kvps[i].split('=');
                if (keyValuePair.length === 2) {
                    if (paramMap[keyValuePair[0]]) {
                        paramMap[keyValuePair[0]].push(decodeURIComponent(keyValuePair[1]));
                    } else {
                        paramMap[keyValuePair[0]] = [decodeURIComponent(keyValuePair[1])];
                    }
                }
            }
        }

        var paramMapKeys = Object.keys(paramMap);
        if (paramMapKeys.length) {
            for (i = 0, len = paramMapKeys.length; i < len; i++) {
                if (paramMap[paramMapKeys[i]].length === 1) {
                    // make it a literal
                    paramMap[paramMapKeys[i]] = paramMap[paramMapKeys[i]][0];
                }
            }
        }

        return paramMap;
    }

    function getImageUrl(image){
        if(!image || !(image.defaultHost && image.endpoint && image.name)){
            return false;
        }
        var type = image.mediaType === 'image' ? 'i' : 'v';
        if(image.endpoint == 'portal') {
            type = 'url';
        }
        return '//'+image.defaultHost+'/'+type+'/'+image.endpoint+'/'+image.name;
    }

    function fetch(){
        var src = getQueryVar('src');
        if(!src){
            console.log('no content `src` param!');
            return;
        }

        return ajaxGet(src)
            .then(parseJson)
            .then(loadSchema)
            .then(setCardMeta)
            .then(produceMap)
            .then(finishLoading);

        function parseJson(data) {
            return JSON.parse(data);
        }

        function finishLoading(data){
            var loader = document.querySelector('.loader');
            var card = document.querySelector('.card');
            if(loader){
                loader.classList.add('hide');
                card.classList.add('loaded');
            }
            return data;
        }
    }

    function trimString(str,length) {
        if(!str || typeof str !== 'string'){
            return '';
        }
        if(str.length<=length){
            return str;
        } else {
            return str.substring(0, length)+'&hellip;';
        }

    }

    function inlineChildContent(parentNode, contentMap, lineage){
        lineage = lineage || [];
        Object.keys(parentNode).forEach(function(key){
            var value = parentNode[key];
            if(key === '@id' && contentMap[value]) {
                if (lineage.indexOf(value) === -1) {
                    Object.keys(contentMap[value]).forEach(function(childKey){
                        parentNode[childKey] = contentMap[value][childKey];
                    });
                    lineage.push(value);
                } else {
                    console.log('circular dependency found ', value, ' already parsed higer up in chain.');
                }
            }
        });
        Object.keys(parentNode).forEach(function(key){
            var value = parentNode[key];
            if(value !== null && typeof value === 'object'){
                parentNode[key] = inlineChildContent(parentNode[key], contentMap, lineage);
            }else if(Array.isArray(value)){
                value.forEach(function(item, i){
                    parentNode[key][i] = inlineChildContent(parentNode[key][i], contentMap, lineage);
                });
            }
        });
        return parentNode;
    }

    function setCardMeta(data) {

        //CMS 2 response
        if(!data.schema){
            return data;
        }

        // determines which card meta data should be used and sets `card.meta` accordingly
        var content = data.inlineContent;
        var schema = data.schema[content["@type"]];
        var params = card.utils.getParams();
        var cardId = params.cardId;

        // Polyfill
        if (!Array.isArray) {
            Array.isArray = function(arg) {
                return Object.prototype.toString.call(arg) === '[object Array]';
            };
        }

        if (Array.isArray(schema.meta.card)) {
            if (cardId) {
                for (var i = 0, len = schema.meta.card.length; i < len; i++) {
                    if (schema.meta.card[i].id === cardId) {
                        card.meta = schema.meta.card[i];
                        break;
                    }
                }
            } else {
                console.log('schema uses a multi-card definition, but no `cardId` was passed in the card request params.');
            }
        } else {
            card.meta = schema.meta.card;
        }

        // pass-through the data to the next step in the process
        return data;
    }

    function buildMapping(card) {
        var map = (card.meta && card.meta.mapping) || {};
        var query = getQueryVars();

        for(var i=0; i < query.length; i++) {
            var param = query[i];
            if(param.key !== 'src' && param.key !== 'cardId' && param.key !== 'templateUrl') {
                map[param.key] = param.value;
            }
        }

        return map;
    }

    function produceMap(data) {
        var map;
        var content = data.inlineContent;

        map = buildMapping(card);

        return mapData(map, content);
    }

    function mapData(map, content){
        var mapped = {};

        // if there is no mapping, just return the content to the rendering process
        if (!map || Object.keys(map).length === 0) {
            return content;
        }

        Object.keys(map).forEach(function(key){
            var mapping = map[key];
            if(Array.isArray(mapping)){
                for(var i = 0; i < mapping.length; i++){
                    if(JSON.pointer.has(content, mapping[i])){
                        mapped[key] = JSON.pointer.get(content, mapping[i]);
                        break;
                    }
                }
            }else{
                try {
                    mapped[key] = JSON.pointer.get(content, mapping);
                } catch(e) {} 
            }
        });

        return mapped;
    }

    function loadSchema(content){
        var contentMap = {};
        content['@graph'].forEach(function(content){
            if(content && content['@id']){
                contentMap[content['@id']] = content;
            }
        });
        var requestedContent = content.result[0]["@id"];
        return {
            content: contentMap,
            inlineContent: inlineChildContent({"@id": requestedContent}, contentMap),
            schema: content.schemas,
            requestedContent: requestedContent
        };
    }

    function getQueryVar(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        return false;
    }

    function getQueryVars() {
        var result = [];
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            result.push({key: decodeURIComponent(pair[0]), value: decodeURIComponent(pair[1])});
        }
        return result;
    }

    function parseUrl(){
        var elm = document.createElement('a');
        elm.href = window.location.href;
        return {
           protocol: elm.protocol,
           hostname: elm.hostname,
           port: elm.port,
           pathname: elm.pathname,
           search: elm.search,
           hash: elm.hash,
           host: elm.host
        };
    }

    function parseString(value) {
        if (value === null || value === undefined) {
            return '';
        }
        switch (typeof value) {
            case 'number':
                return value.toString();
            case 'string':
                // ensure string is sanitized (HTML encoded, dangerous chars etc)
                return sanitize(value);
            default:
                return '';
        }
    }

    // lifted and gently adjusted from https://github.com/angular/angular.js/blob/v1.3.14/src/ngSanitize/sanitize.js#L435
    function sanitize(value) {
        var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        // Match everything outside of normal chars and " (quote character)
        var NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g;

        return value.
            replace(/&/g, '&amp;').
            replace(SURROGATE_PAIR_REGEXP, function(value) {
                var hi = value.charCodeAt(0);
                var low = value.charCodeAt(1);
                return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
            }).
            replace(NON_ALPHANUMERIC_REGEXP, function(value) {
                return '&#' + value.charCodeAt(0) + ';';
            }).
            replace(/</g, '&lt;').
            replace(/>/g, '&gt;');
    }

    function ajaxGet(path) {
        var def = Q.defer();
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function()
        {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    def.resolve(xhr.responseText);
                } else {
                    def.reject(xhr);
                }
            }
        };
        xhr.open("GET", path, true);
        xhr.send();
        return def.promise;
    }

}(window.card = window.card?window.card:{}));
